var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-inherit flex h-full w-full items-center justify-center bg-black/40",class:_vm.loaderTypeStyles},[_c('IconSilverLoader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }